<ng-template #modalContent let-modal>
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ modalTitle | translate }}
    </h6>
    <button
      type="button"
      class="btn-close close-modal-button text-reset"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div
    class="modal-body mx-0 flex-grow-0"
    [ngClass]="{ 'alert-form-box': shakeFrom == true }"
  >
    <form class="add-new-user pt-0" autofil autocomplete="false">
      <div class="row modal-body-form">
        <ng-container *ngFor="let item of fields; let i = index">
          <ng-container
            *ngIf="
              (this.editSource == null && item.isCreateAble) ||
              (this.editSource != null && item.isEditable)
            "
          >
            <div class="col-12 col-md-6 col-lg-6 col-sm-6 col-xxl-6 mb-3">
              <div class="edit-form">
                <label class="form-label" [attr.for]="item.fieldName">
                  {{ item.label | translate }}
                </label>
                <div class="validation-alert-pc-modal">
                  <p>
                    {{ item.message! | translate }}
                  </p>
                </div>

                <!-- 
                 <app-file-drop
                  *ngIf="item.fieldName == 'imageurl'"
                  class="m-3"
                  [shortLink]="item.defaultValue"
                  (childEvent)="item.defaultValue = $event"
                ></app-file-drop> -->

                <input
                  class="input-design form-control"
                  type="time"
                  [(ngModel)]="item.defaultValue"
                  [ngClass]="{ 'is-invalid': item.isInvalid }"
                  *ngIf="item.fieldType == 'TimeSpan'"
                  (change)="checkValidation(item)"
                  (keyup)="checkValidation(item)"
                  [attr.id]="item.fieldName"
                  [ngModelOptions]="{ standalone: true }"
                />

                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': item.isInvalid }"
                  *ngIf="item.fieldType == 'String' || item.fieldType == 'Guid'"
                  [attr.id]="item.fieldName"
                  [(ngModel)]="item.defaultValue"
                  (change)="checkValidation(item)"
                  (keyup)="checkValidation(item)"
                  [ngModelOptions]="{ standalone: true }"
                  [attr.placeholder]="item.placeHolder | translate"
                />

                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': item.isInvalid }"
                  *ngIf="
                    item.fieldType == 'Int32' ||
                    item.fieldType == 'Int64' ||
                    item.fieldType == 'Double' ||
                    item.fieldType == 'double' ||
                    item.fieldType == 'Long'
                  "
                  [attr.id]="item.fieldName"
                  [(ngModel)]="item.defaultValue"
                  (change)="checkValidation(item)"
                  (keyup)="checkValidation(item)"
                  [ngModelOptions]="{ standalone: true }"
                  [attr.placeholder]="item.placeHolder | translate"
                  mask="separator.0"
                  thousandSeparator=","
                />

                <style></style>
                <div [ngClass]="monthName">
                  <input
                    type="text"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': item.isInvalid }"
                    *ngIf="item.fieldType == 'DateTime'"
                    [attr.id]="item.fieldName"
                    [ngModel]="item.defaultValue | dataType : '' : false"
                    [ngModelOptions]="{ standalone: true }"
                    [attr.placeholder]="item.placeHolder | translate"
                    [ngbPopover]="popoverDatapickerfactorDate"
                    #datePicker="ngbPopover"
                    [autoClose]="'outside'"
                    autocomplete="disabled"
                  />

                  <!-- (change)="checkValidation(item)"
                  (keyup)="checkValidation(item)" -->

                  <ng-template #popoverDatapickerfactorDate>
                    <app-data-picker
                      [(childProp)]="item.defaultValue"
                      (changeVariableMonth)="changeMonth($event)"
                    ></app-data-picker>
                  </ng-template>
                </div>

                <input
                  class="form-check-input"
                  type="checkbox"
                  [ngClass]="{ 'is-invalid': item.isInvalid }"
                  *ngIf="item.fieldType == 'Boolean'"
                  [attr.id]="item.fieldName"
                  [(ngModel)]="item.defaultValue"
                  (change)="checkValidation(item)"
                  (keyup)="checkValidation(item)"
                  [ngModelOptions]="{ standalone: true }"
                  [attr.placeholder]="item.placeHolder | translate"
                />

                <div *ngIf="item.isRelational">
                  <select
                    class="select2 form-select form-select-xs"
                    (change)="checkValidation(item)"
                    (keyup)="checkValidation(item)"
                    [(ngModel)]="item.defaultValue"
                    [ngModelOptions]="{ standalone: true }"
                    [ngClass]="{ 'is-invalid': item.isInvalid }"
                    data-allow-clear="true"
                  >
                    <option value="">
                      {{ "selectItem" | translate }}
                    </option>
                    <option
                      *ngFor="let dropDownItem of item.dropDownValue"
                      [attr.value]="dropDownItem.key"
                    >
                      {{ dropDownItem.value }}
                    </option>
                  </select>
<!-- 
                  <app-drop-down-paging
                    [data]="countryDropDown"
                    (ngModelValueChange)="item.defaultValue = $event.id"
                  >
                  </app-drop-down-paging> -->
                </div>
                <div
                  *ngIf="
                    item.dropDownValue != null &&
                    item.dropDownValue.length > 0 &&
                    item.fieldType.indexOf('ArrayList') > -1
                  "
                >
                  <app-multi-select-dropdown
                    (change)="checkValidation(item)"
                    (keyup)="checkValidation(item)"
                    [bindingValue]="item.defaultValue"
                    [list]="item.dropDownValue"
                    (shareCheckedList)="item.defaultValue = $event"
                    [ngClass]="{ 'is-invalid': item.isInvalid }"
                    data-allow-clear="true"
                  >
                  </app-multi-select-dropdown>
                </div>
                <textarea
                  type="text"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': item.isInvalid }"
                  *ngIf="
                    item.fieldType.indexOf('ArrayListu003cStringu003e') > -1
                  "
                  [attr.id]="item.fieldName"
                  [(ngModel)]="item.defaultValue"
                  (change)="checkValidation(item)"
                  (keyup)="checkValidation(item)"
                  [ngModelOptions]="{ standalone: true }"
                  [attr.placeholder]="item.placeHolder | translate"
                ></textarea>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <app-loading-panel *ngIf="!inputFields"></app-loading-panel>
    </form>
  </div>
  <div class="modal-footer border-top p-3">
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="submitModal()"
    >
      {{ "Submit" | translate }}
    </button>
    <button
      type="reset"
      class="btn btn-label-secondary"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "Cancel" | translate }}
    </button>
  </div>
</ng-template>
